module.exports = __webpack_public_path__ + "img/tg-icon.9b4d3a39.svg";